import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import AccountRemittanceContainer from '../../../containers/account_remittance_container';
import {Button, Form, Header, Icon, Popup} from 'semantic-ui-react';
import ReactTable from "react-table";
import Loader from '../../universal/loader';
import {BASE_URL, REMITTANCE} from "../../../constants/app_routes";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import moment from "moment";
import DownloadingIntent from "../../universal/toast";
import {handleFileDownload} from "../../../utils/download_file";


class RemittanceList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            totalEstimate: 0,
            selectedIds:[],
            filterApplied: false,
            fromDate: undefined,
            toDate: undefined,
            dateFiltered: false,
        }
    }

    componentWillMount() {
        this.props.getRemittanceList();
    }

    handleFilterSelection() {
        this.setState({dateFiltered: true,selectedIds:[]});
        if(this.state.fromDate && this.state.toDate) {
            this.props.getRemittanceList(this.state.fromDate, this.state.toDate)
        }
    }

    handleView = (id) => {
        this.props.history.push(`${REMITTANCE}/view/${id}`);
    };

    handleSelection = (id) => {
        let selectedId = this.state.selectedIds;
        const index = selectedId.indexOf(id);
        if( index === -1){
            selectedId.push(id);
        }
        else {
            selectedId.splice(index,1)
        }
        this.setState({selectedIds:selectedId});
    };

    handleAddressFilter = (row,filterValue) => {
        let flag = false;
        if(row !== undefined){
            row.forEach((estimate,i)=>{
                if(estimate.address.replace(/[^\w]/g,'').toUpperCase().indexOf(filterValue.replace(/[^\w]/g,'').toUpperCase()) >= 0){
                    flag = true;
                    return null;
                }
            });
        }
        else {
            flag = true;
        }
        return flag;
    };


    handleDownload = async () => {
        this.setState({isDownloading:true,showDownload:true});
        let URL = BASE_URL+"/export/remittance";
        let fileName = "Remittance List.xlsx";
        if(this.state.dateFiltered && this.state.fromDate && this.state.toDate){
            fileName = "Remittance List -"+moment(this.state.fromDate).format("YYYY-MM-DD")+"-"+moment(this.state.toDate).format("YYYY-MM-DD")+" .xlsx";
            URL = BASE_URL+"/export/remittance?start_date="+this.state.fromDate+"&end_date="+this.state.toDate;
        }
        if(this.state.selectedIds.length > 0){
            URL = BASE_URL+"/export/remittance?ids=["+this.state.selectedIds+"]";
        }
        await handleFileDownload(URL,fileName,'application/xlsx');
        this.setState({isDownloading:false});
    };

    render() {
        const columns = [{
            Header: 'Select',
            id:'selection',
            accessor:'id',
            className: 'center-aligned micro-width',
            headerClassName:'micro-width',
            filterable: false,
            Cell: ({value}) => (
                <div>
                    <input type="checkbox" onClick={(e) => {this.handleSelection(value)}} />
                </div>
            ),
        },{
            Header: 'Date',
            accessor: 'date',
            className: 'center-aligned',
            filterable: true,
        }, {
            Header: 'Remittance Number',
            accessor: 'remittance_number',
            className: 'center-aligned',
            filterable: true
        }, {
            Header: 'Clerk Name',
            accessor: 'clerk_profile_name',
            className: 'max-width',
            headerClassName: 'max-width',
            filterable: true
        }, {
            Header: 'Address Detail',
            id:'address',
            className:'caddress-width',
            headerClassName:'caddress-width',
            accessor:d => d['remittance_estimates'],
            filterable: true,
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return this.handleAddressFilter(row[id],filter.value);
            },
            Cell: ({value}) => (
                <div>
                    <Popup
                        trigger={<span>{value[0]['address']}</span>}
                        content={<ol> {value.map((estimate, i) => {
                            return(<li className="pad-bottom" key={"Address "+i}>{estimate.address}</li>)}
                        )}</ol>}
                        position='top left'
                        on='hover'
                        wide
                        header='Addresses'
                        flowing
                        hideOnScroll
                    />
                </div>
            )
        },{
            Header: 'Total Estimate',
            accessor: 'total_amount',
            filterable: true,
            Cell: ({value}) => (
                <div>
                    <span>£ {value}</span>
                </div>
            )
        }, {
            Header: 'Remittance Status',
            className: 'center-aligned',
            accessor: 'status',
            Cell: ({value}) => (
                <div>
                    <Button size='mini' fluid><span className="format-capitalize">{value}</span></Button>
                </div>
            ),
            filterable: true
        }, {
            Header: 'Action',
            id: 'edit',
            className: 'center-aligned',
            accessor: 'id',
            sortable:false,
            Cell: ({value}) => (
                <div>
                    <Button basic compact icon positive size='mini' onClick={(e) => this.handleView(value)}><Icon
                        name='eye'/>View</Button>
                </div>
            )
        }];
        return (<div style={{minHeight: '450px'}} className="pad-bottom">
            <div style={{position: 'absolute',top:'-100px',right:'0'}}>
                <Popup
                    trigger={<Button icon='filter' labelPosition='right' content='Date'/>}
                    content={<div>
                        <div><Header content="Filter Remittance By Date"/><Form><span><b>From: </b><DayPickerInput
                            placeholder="From"
                            dayPickerProps={{
                                todayButton: 'Today',
                                firstDayOfWeek : 1,
                            }}
                            format="DD-MM-YYYY"
                            value={moment().format("DD-MM-YYYY")}
                            formatDate={formatDate}
                            parseDate={parseDate}
                            onDayChange={day => {day ? this.setState({fromDate: day,toDate:day}): this.setState({fromDate:undefined})}}/></span>
                            <span><b>To: </b><DayPickerInput
                                placeholder="To"
                                format="DD-MM-YYYY"
                                formatDate={formatDate}
                                value={this.state.toDate}
                                parseDate={parseDate}
                                dayPickerProps={{
                                    disabledDays: {before: this.state.fromDate},
                                    todayButton: 'Today',
                                    firstDayOfWeek : 1,
                                }} onDayChange={day => {day ?this.setState({toDate: day}): this.setState({endDate:undefined}) }}/></span></Form></div>
                        <br/>
                        <div style={{width:'100%'}} className="right-aligned">
                        <Button content="Get Remittances" primary
                                     onClick={() => this.handleFilterSelection()}/>
                        </div>
                        </div>}
                    on='click'
                    position="bottom left"
                    flowing
                    hideOnScroll
                    wide
                />
            </div>
            <div style={{position:'absolute',top:'-100px',right:'150px'}}>
                <Button content="Export Remittance" primary onClick={this.handleDownload}/>
            </div>
            <div>
                {this.state.dateFiltered &&
                <div className="date-range-info"><span>Showing Remittances from :</span><span
                    className="format-bold">{moment(this.state.fromDate).format("LL").toString()}</span><span> to </span><span
                    className="format-bold">{moment(this.state.toDate).format("LL").toString()}</span>
                </div>}
            </div>
            {!this.props.isFetching && <ReactTable
                data={this.props.remittances}
                columns={columns}
                defaultFilterMethod={(filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                }}
                minRows={11}
                showPagination={false}
                defaultPageSize={10000}
                style={{
                    height: '550px'
                }}
                noDataText="No Remittances Found"
            />}
            {this.props.isFetching && <Loader/>}
            {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
        </div>)
    }
}

export default AccountRemittanceContainer(withRouter(RemittanceList));


// WEBPACK FOOTER //
// ./src/views/accounts/remittance/remittances.js